import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const HorizontalScroll = () => {
  gsap.registerPlugin(ScrollTrigger);
  // 実績 横スクロール
  const listWrapperEl = document.querySelector('.side-scroll-list-wrapper');
  const listEl = document.querySelector('.side-scroll-list');
  const widthEl = document.querySelector('.js-get-width');
  const paddingLeft = parseInt(window.getComputedStyle(listEl).paddingLeft, 10);

  gsap.matchMedia().add('(min-width: 200px) and (max-width: 767px)', () => {
    gsap.to(listEl, {
      x: () =>
        `${listWrapperEl.clientWidth - paddingLeft * 2 - widthEl.clientWidth}`,
      ease: 'none',
      scrollTrigger: {
        trigger: '.side-scroll',
        start: '-25% top',
        end: () => `+=${paddingLeft * 4}`,
        scrub: 0.7,
        pin: true,
      },
    });
  });
  gsap.matchMedia().add('(min-width: 768px)', () => {
    gsap.to(listEl, {
      x: `${listWrapperEl.clientWidth - paddingLeft * 2 - widthEl.clientWidth}`,
      ease: 'none',
      scrollTrigger: {
        trigger: '.side-scroll',
        start: 'top top',
        end: `+=${paddingLeft * 4}`,
        scrub: 0.5,
        pin: true,
        // markers: true,
      },
    });
  });
};

export default HorizontalScroll;
